<template>
  <div>
    <div class="md-layout-item md-size-100 mt-30 center-content mnue-employees">
      <md-button @click="personal_data" class="btn_nanosoft"
        >البيانات الشخصية</md-button
      >
      <md-button @click="Functional_data" class="btn_nanosoft">
        البيانات الوظيفية
      </md-button>
      <md-button
        v-if="isSalariesEnabled == 'true'"
        @click="Financial_data"
        class="md-success btn_nanosoft"
        >البيانات المالية</md-button
      >
      <md-button @click="Qualifications_" class="btn_nanosoft"
        >المؤهلات العلمية</md-button
      >
      <md-button @click="Vacation" class="btn_nanosoft">
        أرصدة وخصميات الإجازات السنوية</md-button
      >
      <md-button @click="JobStatus" class="btn_nanosoft"
        >الحالة الوظيفية</md-button
      >
      <!-- <md-button @click="Assignment" class=" btn_nanosoft">الإنتداب لجهة اخرى</md-button> -->
      <md-button @click="EmployeeDocuments" class="btn_nanosoft"
        >مستندات الموظف</md-button
      >
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <form>
          <md-card class="p-25">
            <md-card-content>
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-30 md-small-size-100 mt-50 ml-15"
                >
                  <md-field>
                    <label>الموظف</label>
                    <md-input
                      v-model="fullName"
                      v-if="employeeId != 'new'"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-30 mt-50 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>رقم الملف المالي</label>
                    <md-input type="number" v-model="FileNumber"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="privateCompanyMode == 'false' || !privateCompanyMode"
                  class="md-layout-item md-size-30 mt-50 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>الرقم المالي</label>
                    <md-input
                      type="number"
                      v-model="FinancialNumber"
                    ></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-50 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>نسبة خصم الراتب</label>
                    <md-input v-model="SalaryPercentage"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-50 ml-15">
                  <md-field>
                    <ClearButton @click.native="clearfield('PaymentMethod')" />
                    <p class="validate">*</p>
                    <label>آلية سداد المرتب</label>
                    <md-select v-model="PaymentMethod">
                      <md-option value="1">نقدي</md-option>
                      <md-option value="2">صك</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-if="PaymentMethod != 1 && PaymentMethod"
                  class="md-layout-item md-size-30 mt-25 ml-15 clear-relative"
                >
                  <label>المصرف</label>
                  <model-list-select
                    class="input-must-rtl"
                    :list="Bank"
                    v-model="BankId"
                    option-value="key"
                    option-text="value"
                  ></model-list-select>
                  <ClearButton
                    class="absolute-clear-button"
                    @click.native="clearfield('BankId')"
                  />
                </div>

                <div
                  v-if="PaymentMethod != 1 && PaymentMethod"
                  class="md-layout-item md-size-30 mt-25 ml-15 clear-relative"
                >
                  <label>فروع المصرف</label>
                  <model-list-select
                    class="input-must-rtl"
                    :list="BankBranch"
                    v-model="BankBranchId"
                    option-value="key"
                    option-text="value"
                    placeholder="فروع المصرف"
                  ></model-list-select>
                  <ClearButton
                    class="absolute-clear-button"
                    @click.native="clearfield('BankBranchId')"
                  />
                </div>

                <div
                  v-if="PaymentMethod != 1 && PaymentMethod"
                  class="md-layout-item md-size-30 mt-50 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>رقم الحساب</label>
                    <md-input type="number" v-model="AccountNumber"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-50 ml-15">
                  <md-field>
                    <ClearButton @click.native="clearfield('WarrantyType')" />
                    <p class="validate">*</p>
                    <label>نوع الضمان</label>
                    <md-select v-model="WarrantyType">
                      <md-option value="1">لا يوجد</md-option>
                      <md-option value="3">يوجد</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-if="WarrantyType == 3"
                  class="md-layout-item md-size-30 mt-50 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>رقم الضمان</label>
                    <md-input type="number" v-model="SecurityNumber"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-50 ml-15">
                  <md-field>
                    <ClearButton
                      @click.native="clearfield('salaryCalculationMechanism')"
                    />
                    <p class="validate">*</p>
                    <label>آلية احتساب المرتب</label>
                    <md-select v-model="salaryCalculationMechanism">
                      <md-option :value="1">قيمة ثابتة</md-option>
                      <md-option :value="2"> حسب ساعات الحضور </md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-if="privateCompanyMode == 'false' || !privateCompanyMode"
                  class="md-layout-item md-size-30 mt-50 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>الدرجة المالية</label>
                    <md-input disabled v-model="FinancialDegree"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="privateCompanyMode == 'false' || !privateCompanyMode"
                  class="md-layout-item md-size-30 md-small-size-100 mt-50 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>العلاوة المالية</label>
                    <md-input disabled v-model="FinancialBonuse"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="privateCompanyMode == 'false' || !privateCompanyMode"
                  class="md-layout-item md-size-30 md-small-size-100 mt-50 ml-15"
                >
                  <md-field>
                    <label> شهر العلاوة المالية </label>
                    <md-input v-model="BonusDueDate"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="salaryCalculationMechanism == 1"
                  class="md-layout-item md-size-30 mt-50 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <p v-if="PaymentMethod == 1" class="validate">*</p>
                    <label>ساعات العمل الشهرية</label>
                    <md-input v-model="TotalWorktime"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="salaryCalculationMechanism == 1"
                  class="md-layout-item md-size-30 mt-50 ml-15"
                >
                  <md-field>
                    <p v-if="PaymentMethod == 1" class="validate">*</p>
                    <label>المرتب الأساسي</label>
                    <md-input
                      type="number"
                      :disabled="GetBasicSalaryFromTable"
                      v-model="BasicSalary"
                    ></md-input>
                  </md-field>
                </div>

                <div
                  v-if="salaryCalculationMechanism == 2"
                  class="md-layout-item md-size-30 mt-50 ml-15"
                >
                  <md-field>
                    <label>قيمة ساعة الدوام العادي</label>
                    <md-input
                      type="number"
                      v-model="regularShiftManHour"
                    ></md-input>
                  </md-field>
                </div>
                <div
                  v-if="salaryCalculationMechanism == 2"
                  class="md-layout-item md-size-30 mt-50 ml-15"
                >
                  <md-field>
                    <label>قيمة ساعة دوام المناوبة</label>
                    <md-input
                      type="number"
                      v-model="nightShiftManHour"
                    ></md-input>
                  </md-field>
                </div>

                <div
                  v-if="
                    salaryCalculationMechanism == 1 &&
                    privateCompanyMode == 'false'
                  "
                  class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-50"
                >
                  <md-checkbox v-model="GetBasicSalaryFromTable">
                    الإحتساب من جدول المرتبات</md-checkbox
                  >
                </div>

                <div class="md-layout-item md-size-30 mt-50 ml-15">
                  <md-field>
                    <ClearButton @click.native="clearfield('currencyType')" />

                    <label>نوع عملة المرتب</label>
                    <md-select v-model="currencyType">
                      <md-option :value="1">دينار ليبي</md-option>
                      <md-option :value="2">دولار</md-option>
                      <md-option :value="3">يورو</md-option>
                      <md-option :value="4">دينار تونسي</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-50 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>قيمة الحد الأقصى للاستقطاعات</label>
                    <md-input
                      type="number"
                      v-model="maxDeductionLimitValue"
                    ></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-100 mt-25 center-content">
                  <md-button
                    v-if="!isEndedService"
                    @click="Save"
                    class="md-success btn_nanosoft"
                    >حفظ</md-button
                  >
                  <md-button @click="gobBack" class="md-info btn_nanosoft"
                    >رجوع</md-button
                  >
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../../../../components/service/HTTP.js";
import { SlideYDownTransition } from "vue2-transitions";
import { ModelListSelect } from "vue-search-select";

import { extend } from "vee-validate";
import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";
import env from "../../../../../../env";
extend("required", required);
extend("numeric", numeric);
extend("regex", regex);
extend("confirmed", confirmed);
export default {
  async created() {
    this.init();
    this.isSalariesEnabled = localStorage.getItem("isSalariesEnabled");
    this.privateCompanyMode = localStorage.getItem("privateCompanyMode");
  },

  components: {
    ModelListSelect,
  },

  data() {
    return {
      isEndedService: false,
      privateCompanyMode: false,
      id: null,
      fullName: null,
      FileNumber: null,
      maxDeductionLimitValue: null,
      FinancialNumber: null,
      SalaryPercentage: 0,
      BankId: null,
      Bank: [],
      BankBranchId: null,
      BankBranch: [],
      AccountNumber: null,
      SecurityNumber: null,
      PaymentMethod: null,
      currencyType: null,
      WarrantyType: 0,
      FamilyAllowance: 0,
      LeadershipAllowance: 0,
      SupervisionAllowance: 0,
      StandingCommitteAllowance: 0,
      CommitteAllowance: 0,
      DelegationAllowance: 0,
      TotalWorktime: 0,
      BasicSalary: 0,
      BonusDueDate: 0,
      GetBasicSalaryFromTable: false,
      salaryCalculationMechanism: null,
      regularShiftManHour: 0,
      nightShiftManHour: 0,
      FinancialDegree: 0,
      FinancialBonuse: 0,
      errorMessage: null,
    };
  },

  watch: {
    async BankId() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result_BankBranch = await axios.get(
          `${env.HR()}/api/bank-branches/load/${this.BankId}`,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        this.BankBranch = result_BankBranch.data.data;
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },
  },

  methods: {
    clear_BankId() {
      this.BankId = null;
    },
    clearfield(field) {
      this[field] = "";
    },
    async Save() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let employeeId = this.$route.params.id;
        let token = atob(T);

        // if (!this.BasicSalary && this.GetBasicSalaryFromTable == false) {
        //   return this.notifyVue(
        //     "top",
        //     "center",
        //     "danger",
        //     "عفواً، الرجاء ادخال المرتب الأساسي"
        //   );
        // }

        if (this.SalaryPercentage == null || this.SalaryPercentage == null) {
          this.SalaryPercentage = 0;
        }

        let schema = {
          FileNumber: this.FileNumber,
          maxDeductionLimitValue: Number(this.maxDeductionLimitValue),
          FinancialNumber: this.FinancialNumber,
          SalaryPercentage: this.SalaryPercentage,
          BankId: this.BankId,
          BankBranchId: this.BankBranchId,
          AccountNumber: this.AccountNumber,
          SecurityNumber: this.SecurityNumber,
          WarrantyType: parseInt(this.WarrantyType),
          PaymentMethod: parseInt(this.PaymentMethod),
          currencyType: parseInt(this.currencyType),
          FamilyAllowance: this.FamilyAllowance,
          LeadershipAllowance: this.LeadershipAllowance,
          SupervisionAllowance: this.SupervisionAllowance,
          StandingCommitteAllowance: this.StandingCommitteAllowance,
          CommitteAllowance: this.CommitteAllowance,
          DelegationAllowance: this.DelegationAllowance,
          TotalWorktime: Number(this.TotalWorktime),
          BasicSalary: this.BasicSalary,
          BonusDueDate: this.BonusDueDate,
          GetBasicSalaryFromTable: this.GetBasicSalaryFromTable,
          salaryCalculationMechanism: this.salaryCalculationMechanism,
          regularShiftManHour: this.regularShiftManHour,
          nightShiftManHour: this.nightShiftManHour,
        };

        if (this.salaryCalculationMechanism === 1) {
          schema.regularShiftManHour = 0;
          schema.nightShiftManHour = 0;
        } else if (this.salaryCalculationMechanism === 2) {
          schema.TotalWorktime = 0;
          schema.BasicSalary = 0;
          schema.GetBasicSalaryFromTable = false;
        }

        let result = await axios.put(
          `${env.HR()}/api/hr/employees/${employeeId}/finantial-info`,
          schema,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        return this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
      } catch (error) {
        this.message(error);
      }
    },

    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    async init() {
      try {
        let employeeId = this.$route.params.id;
        if (employeeId == "new") {
          return;
        }
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        if (employeeId !== null) {
          let result = await axios.get(
            `${env.HR()}/api/hr/employees/LoadFinancialInfo/${employeeId}`,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );

          this.isEndedService = result.data.data.isEndedService;

          this.Bank = result.data.data.banks;
          this.fullName = result.data.data.fullName;
          this.FileNumber = result.data.data.fileNumber;
          this.maxDeductionLimitValue = result.data.data.maxDeductionLimitValue;
          this.FinancialNumber = result.data.data.financialNumber;
          this.SalaryPercentage = result.data.data.salaryPercentage;
          this.BankId = result.data.data.bankId;
          this.BankBranchId = result.data.data.bankBranchId;
          this.AccountNumber = result.data.data.accountNumber;
          this.SecurityNumber = result.data.data.securityNumber;
          this.WarrantyType = result.data.data.warrantyType;
          this.PaymentMethod = result.data.data.salaryPaymentMethod;
          this.currencyType = result.data.data.currencyType;
          this.FamilyAllowance = result.data.data.familyAllowance;
          this.LeadershipAllowance = result.data.data.leadershipAllowance;
          this.SupervisionAllowance = result.data.data.supervisionAllowance;
          this.StandingCommitteAllowance =
            result.data.data.standingCommitteAllowance;
          this.CommitteAllowance = result.data.data.committeAllowance;
          this.DelegationAllowance = result.data.data.delegationAllowance;
          this.TotalWorktime = result.data.data.totalWorktime;
          this.BasicSalary = result.data.data.basicSalary;
          this.BonusDueDate = result.data.data.bonusDueDate;

          this.GetBasicSalaryFromTable =
            result.data.data.getBasicSalaryFromTable;
          this.salaryCalculationMechanism =
            result.data.data.salaryCalculationMechanism;
          this.FinancialDegree = result.data.data.financialDegree;
          this.regularShiftManHour = result.data.data.regularShiftManHour;
          this.nightShiftManHour = result.data.data.nightShiftManHour;
          this.FinancialBonuse = result.data.data.financialBonuse;
        }
      } catch (error) {
        this.message(error);
      }
    },

    gobBack() {
      this.$router.push("/pages/employees");
    },

    Functional_data() {
      let employeeId = this.$route.params.id;
      if (employeeId) {
        this.$router.push(
          "/pages/employee/Functionaldata/" + this.$route.params.id
        );
      }
    },

    Financial_data() {
      this.$router.push(
        "/pages/employee/Financialdata/" + this.$route.params.id
      );
    },

    personal_data() {
      this.$router.push("/pages/employee/info/" + this.$route.params.id);
    },

    Qualifications_() {
      this.$router.push(
        "/pages/employee/Certifications/" + this.$route.params.id
      );
    },

    Vacation() {
      this.$router.push("/pages/employee/Vacation/" + this.$route.params.id);
    },
    JobStatus() {
      this.$router.push("/pages/employee/JobStatus/" + this.$route.params.id);
    },

    Assignment() {
      this.$router.push("/pages/employee/Assignment/" + this.$route.params.id);
    },

    EmployeeDocuments() {
      this.$router.push(
        "/pages/employee/EmployeeDocuments/" + this.$route.params.id
      );
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
  },
};
</script>
